import { render } from "./membership-plans.vue?vue&type=template&id=95fa7a3e"
import script from "./membership-plans.vue?vue&type=script&lang=js"
export * from "./membership-plans.vue?vue&type=script&lang=js"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__